<script setup lang="ts">
export type SegmentedTabOption = {
  id: string
  label: string
  count?: number
}

defineProps<{
  tabs: SegmentedTabOption[]
  modelValue: string
  ariaLabel?: string
}>()

const emit = defineEmits<{
  'update:modelValue': [id: string]
}>()

const selectTab = (id: string) => {
  emit('update:modelValue', id)
}

const tabAriaLabel = (tab: SegmentedTabOption) => {
  if (tab.count == null) return tab.label
  return `${tab.label}, ${tab.count}`
}
</script>

<template>
  <div class="sa-tabs" role="tablist" :aria-label="ariaLabel">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="sa-tab"
      :class="{ 'sa-tab--active': modelValue === tab.id }"
      role="tab"
      :aria-selected="modelValue === tab.id"
      :aria-label="tabAriaLabel(tab)"
      @click="selectTab(tab.id)"
    >
      <span class="sa-tab__label">{{ tab.label }}</span>
      <span v-if="tab.count != null" class="sa-tab__count">{{ tab.count }}</span>
    </button>
  </div>
</template>
